import React from 'react';

interface OtpVerifyBannerProperties {
  imageSrc: string;
  bannerTittle?: string;
  bannerDescription?: string;
}

/**
 * OTP verification components
 */
function OtpVerifyBanner(properties: OtpVerifyBannerProperties) {
  const { imageSrc, bannerTittle, bannerDescription } = properties;
  return (
    <div className="otp-verify-banner-wrap">
      <div className="banner-top">
        <img src={imageSrc} alt="" className="banner-image" />
      </div>
      <div className="banner-bottom">
        <h1>{bannerTittle}</h1>
        <p>{bannerDescription}</p>
      </div>
      <div className="curved-border" />
    </div>
  );
}

OtpVerifyBanner.defaultProps = {
  bannerTittle: '',
  bannerDescription: '',
};

export default OtpVerifyBanner;
